import { TravelstatusMdl } from "./TravelBindMdl";
import { TravelPromoMdl } from "./TravelPromoMdl";

export class TravelProposalMdl
{
   public  RegNo: string;
   public ProposalNo: number;
   public ProposalDate: Date | string;
   public ProposalEffFrom: Date | string;
   public ProposalEffTo: Date | string;
   public ProductCode: string;
   public SchemeCode: string;
   public Insured_Name: string;
   public Insured_Name_EN: string;
   public Insured_Name_AR: string;
   public IDOB: Date | string;
   public IPassportNo: string;
   public  Insured_IDNo: string;
   public  PlaceOfBirth: string;
   public  IOccupation: string;
   public  Salary: string;
   public  IMobileNo: string;
   public ICity: string;
   public IPoBoxNo: string;
   public IPostalcode: string;
   public IPhoneNo: string;
   public InsuranceType: string="";
   public ZoneCode: string="";
   public PlanCode: string="";
   public TravelFrom:  Date=new Date();
   public TravelTo:  Date=new Date();
   public NoofDays: number;
   public UserId: string;
   public TotalPremium: string;
   public Insured_BuildingNo: string;
   public Insured_AdditionalCode: string;
   public Insured_AreaName: string;
   public Insured_UnitNo: string;
   public Insured_StreetName: string;
   public Insured_DistName: string;
   public Insured_PostalCode: string;
   public Insured_WBuildingNo: string;
   public Insured_WCity: string;
   public Insured_WPostalCode: string;
   public Insured_WAreaName: string;
   public Insured_POCity: string;
   public  Insured_POPostalCode: string;
   public  Insured_PoPoboxNo: string;
   public  Insured_WAdditionalCode: string;
   public Insured_EmailId: string;
   public Gender: string;
   public Insured_WorkPlace: string;
   public Insured_Nationality: string;
   public WaselAddress: boolean;
   public  POBoxAddress: boolean;
   public  AddressType: string;
   public LangFlag: string;
   public coverList: Array<TravelcoversMdl>=new Array<TravelcoversMdl>();
   public  passList: Array<PassMdl>=new Array<PassMdl>();
   public nomineeList: Array<NomineeMdl>=new Array<NomineeMdl>();
  

   public NoOfAdults: number;
   public AdultsPremium: string;
   public NoOfChilds: number;
   public ChildsPremium: string;
   public InsuredPremium: string;
   public FamilyPremium: string;


   public Insured_Name_Exists: boolean;
   public Gender_Exists: boolean;
   public IDOB_Exists: boolean;
   public HDOB: string;
   public HDOB_Exists: boolean;
   public Age: string;
   public AgeValid: boolean;
   public IDOBStr: string;
   public Insured_NationalityExists: boolean;
   public Insured_Nationality_En: string;
   public Insured_Nationality_Ar: string;
   public NomineeSelected: boolean;

   public sponsorId: string;
   public IDExpiry: string;
   public IDDob: string;

   public CalculatedPremium: string;

   public VATPercent: number;
   public VATAmount: number;
   public VATBeforePremium: number;

   public PreSig: string;

   public BankCode: string;
   public IBAN: string;

   public IBAN1: string;
   public IBAN2: string;
   public IBAN3: string;
   public IBAN4: string;
   public IBAN5: string;
   public IBAN6: string;

   public PromoCode: string;
   public PromoDiscount: number;
   public PromoDiscountPer: number;
   public PromoID: number;
   public isPromoApply: string;
   public BeforePromoAmt: number;
   public PromoType: string;

   public saudiFetched: boolean;
   public PostCityFetched: boolean;

   public StreetFetched: boolean;
   public BuidingNoFetched: boolean;
   public AddCodeFetched: boolean;
   public DistFetched: boolean;
   public PostFetched: boolean;

   public CrossSellDiscountPer: number;
   public CrossSellDiscountAmt: number;
   public CrossSellDiscountType:string;

   public buildingNumberExists: boolean;
   public additionalNumberExists: boolean;
   public districtExists: boolean;
   public postCodeExists: boolean;
   public streetNameExists: boolean;
   public cityExists: boolean;
   public Userid: string;

   public GrossPremium: number;
   public isProposalEdit: boolean | null;
   public EditedProposalNo: string;

   

   public TravelFromDate:string;
   public TravelToDate:string;
   public Promoobj:TravelPromoMdl=new TravelPromoMdl();
   public UPRVAT:number;
   public IsHigherPosition:boolean;
   public HigherPositionCode: number
   public ReferredBy: string;
   public AmericanID: string;


   public DepartureAirport:string;
   public TransitAirport:string;
   public DestinationAirport:string;
   public IsVaccinated:boolean;
   public PrefCommLng:string;
   public PrefCommType:string;
   public InsuredIDCopy:string;
   public PassportIDCopy:string;

   public UserDiscountPer: number;
   public UserDiscountAmt: number;

}
export class TravelcoversMdl
{
    public CoverCode: string;
    public CoverDescEn: string;
    public CoverDescAr: string;
    public Quantity: number;
    public Price: number;
    public Amount: number;
    public SumInsured: number;
    public IsBrokerComm: boolean;
    public BrokerComm: number;
    public TariffId: number;
    public isMandatory: boolean;
    public isChecked: boolean;

}
export class PassMdl
{
    public sno: number;
    public NAME: string;
    public  RelationShip: string;
    public  DOB: Date | string;
    public  Sex: string;
    public  PassportNo: string;
    public IdentityNo: string;
    public NationalityCode: number;
    public NatEn: string;
    public NatAr: string;
    public  GenderEn: string;
    public  GenderAr: string;  
    public RelationShipEn:string;
    public RelationShipAr:string;
    public GenderCode:number;
    public RelationCode:number;
    public IDCopy: string;
    public PassportCopy: string;
    public IDCopyName: string;
    public PassportCopyName: string;
   

}
export class NomineeMdl
{
    public SNo: number;
    public MemberName: string;
    public BeneficiaryName: string;
    public RelationShip: string;
    public SharePercent: string;
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/TravelProposalMdl.ts